var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"edit-page"}},[_c('side-nav'),_c('div',{attrs:{"id":"edit-page-content"}},[_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('form-schema',{attrs:{"submit-label":"Update","item-data":_vm.locationInfo,"locale-options":_vm.localeOptions,"can-submit":_vm.canSubmit,"submit-func":_vm.updateLocationFunc}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }